import rem from 'polished/lib/helpers/rem';
import { makeStyles } from 'tss-react/mui';

type Props = {
  isSmall: boolean;
};

export default makeStyles<Props, 'checked' | 'track'>()((
  { palette, transitions },
  { isSmall },
  classes
) => {
  const togglePadding = 2;
  const toggleWidth = isSmall ? 32 : 44;
  const toggleHeight = isSmall ? 20 : 24;
  const thumbWidth = toggleHeight - 2 * togglePadding;
  const thumbHeight = thumbWidth;
  const trackBorderRadius = toggleHeight / 2;
  const translationLength = toggleWidth - thumbWidth - 2 * togglePadding;

  return {
    root: {
      width: rem(toggleWidth),
      height: rem(toggleHeight),
      padding: rem(0),
    },
    switchBase: {
      padding: rem(togglePadding),
      [`&.${classes.checked}`]: {
        transform: `translateX(${rem(translationLength)}) !important`,
      },
      '&.MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: `${palette.primary.main}`,
      },
      '&.MuiSwitch-colorPrimary.Mui-disabled + .MuiSwitch-track': {
        backgroundColor: palette.neutral[700],
        opacity: 1,
      },
    },
    thumb: {
      width: rem(thumbWidth),
      height: rem(thumbHeight),
      color: palette.common.white,
      boxShadow: 'none',
    },
    track: {
      borderRadius: rem(trackBorderRadius),
      backgroundColor: `${palette.neutral[700]}`,
      border: 'none',
      opacity: 1,
      transition: transitions.create(['background-color'], {
        duration: '0.2',
        easing: 'ease-out',
      }),
    },
    checked: {
      color: palette.common.white,
    },
    focusVisible: {
      color: palette.primary.main,
    },
  };
});
